<template>
  <div class="container">

<!-- modal -->
     <b-modal id="modal-lg" size="lg" title="Login">


          <div class="panal-modal">
            <div>

              <div class="panal-header-modal"> {{ info.PageName ? info.PageName : '' }}</div>
              <div class="panal-body-modal">

                <div v-html="info.PageDescription"></div>
              </div>
            </div>



          </div>

          <div class="panal-modal" v-for="help in info.HelpSection" :key="help.serial">
            <div>

              <div class="panal-header-modal"> {{ help.SectionName }}</div>
              <div class="panal-body-modal">

                <div v-html="help.SectionDescription"></div>
              </div>
            </div>



          </div>







        </b-modal>
    

    <div class="row">
      <div class="align-items-center w-100 text-white mt-5">
        <h1 class="align-items-center mt-40" align="center">Welcome</h1>
        <p class="align-items-center" align="center">Sinai Recognized University for your bright future
          </p>
      </div>
    
    

      <div class="col-md-4 mx-auto">
        <div class="panal card-container">
          <div class="panal-header"><span>Login</span> <span class="pull-right"><b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="info">
          <font-awesome-icon icon="info" />
        </b-button></span></div>

          <div class="col-md-9 mx-auto ">
                    <form name="form" @submit.prevent="handleLogin">
                      <div class="form-group mt-40">

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <font-awesome-icon icon="user" />
                            </div>
                          </div>
                          <input v-model="ApplicantData.Username" v-validate="'required'" type="text"
                            class="form-control" name="username" placeholder="Username" />
                        </div>
                        <div v-if="errors.has('username')" class="alert alert-danger" role="alert">Username is required!
                        </div>
                      </div>
                      <div class="form-group mt-20">
                        <div class="input-group">

                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <font-awesome-icon icon="lock" />
                            </div>
                          </div>


                          <input v-model="ApplicantData.Password" v-validate="'required'" type="password"
                            class="form-control" name="password" placeholder="Password" />
                        </div>

                        <div v-if="errors.has('password')" class="alert alert-danger" role="alert">Password is required!
                        </div>
                      </div>
                      <div class="form-group mt-40">
                        <button class=" btn-block btn btn-outline-secondary" :disabled="loading">
                          <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                          <span>Login</span>
                        </button>
                      </div>
                      <div class=" mt-40"></div>
                      <h5 class="divider">OR</h5>
                      <div class=" mt-40"></div>



                      <div class="form-group">
                        <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
                      </div>
                    </form>
                    <div class="form-group">
                      <button class=" btn-block btn btn-outline-secondary" @click="$router.push('register')">

                        <span>CREATE NEW ACCOUNT</span>
                      </button>
                    </div>
                      
                       <div class="form-group">
                      <b-link class=" " @click="$router.push('ForgetPassword')">

                        <span>Forget Password</span>
                      </b-link>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      


</template>

<script>
  import {
    User
  } from '../models/user';
  import {
    ApplicantData
  } from '../models/Applicant'
import ApplicantService from '../services/Applicant/Applicant.service';
 
  export default {
    beforeCreate: function() {
        document.body.className = 'home';
    },
    components: {
    
    },
    name: 'Login',
    data() {
      return {
        user: new User('', ''),
        ApplicantData: new ApplicantData('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
          '', '', '', '',
          ''),
        loading: false,
        message: '',
        info:''
      };
    },
    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      }
    },
    created() {
      if (this.loggedIn) {
        this.$router.push('/dataapp');
      }
    },
    mounted(){
 let id = 2;
 ApplicantService.GetHelpPages(id).then(response => {
        this.info = response.data
      });
    },
    methods: {
      handleLogin() {
        this.loading = true;
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
            this.loading = false;
            return;
          }
          if (this.ApplicantData.Username && this.ApplicantData.Password) {

            this.$store.dispatch('auth/login', this.ApplicantData).then(
              () => {
                this.$router.push('/home');
              },
              error => {
                this.loading = false;
                this.message =
                  (error.response && error.response.data && error.response.data.Message) ||
                  error.message ||
                  error.toString();
              }
            );
          }
        });
      }
    }
  };
</script>

<style scoped>
  label {
    display: block;
    margin-top: 10px;
  }
.info{
  position: absolute;
    right: 50px;
}
  .card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
  }

  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }

  .profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .panal {
    background: #0000009e;
    border-radius: 10px 10px 0px 0px;
    color: #fff;
    padding: 0px 0px 20px 0px;

  }

  .panal-header {
    background: #FFFFFF;
    color: #285475;
    text-align: center;
    border-radius: 10px 10px 0px 0px;
    padding: 15px;
    font-size: 30px;
    font-weight: bold;
    -moz-box-shadow: inset 0 0 5px #000000;
    -webkit-box-shadow: inset 0 0 5px #000000;
    box-shadow:inset 0 0 5px #000000
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 40px;
  }

  .form-control {

    color: #ffffff;
    background-color: #9191916b !important;
    background-clip: padding-box;
    border: 1px solid #ced4da75 !important;
  }

  .btn-outline-secondary {
    color: #ffffff;
    border-color: #ffffff;
  }

  .divider {
    font-size: 20px;
    margin: -0.65em auto -0.45em;
    overflow: hidden;
    text-align: center;
    line-height: 1.2em;
  }

  .divider:before,
  .divider:after {
    content: "";
    vertical-align: top;
    display: inline-block;
    width: 50%;
    height: 0.65em;
    border-bottom: 1px solid #fff;
    margin: 0 2% 0 -55%;
  }

  .divider:after {
    margin: 0 -55% 0 2%;
  }


  ::placeholder {
    color: #fff !important;
    opacity: 1;
    /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff !important;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #fff !important;
  }

  .form-control:focus {
    color: #ffffff !important;
  }
  .panal-modal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header-modal{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body-modal{
    padding:20px;
    color:#333;
}
  @import url('../assets/style.css');

</style>